(() => {
  // Halifax timezone follows both AST and ADT, irrespective of the buyer's clock.
  function dispatchMessage(now, closedDates = []) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Halifax', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).map(part => [part.type, part.value]));
    const localDay = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const open = date => date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !closedDates.includes(date.toISOString().slice(0, 10));
    if (open(localDay) && Number(parts.hour) < 14) return 'Ships today';
    const next = new Date(localDay);
    do { next.setUTCDate(next.getUTCDate() + 1); } while (!open(next));
    const days = Math.round((next - localDay) / 86400000);
    const label = days === 1 ? 'tomorrow' : new Intl.DateTimeFormat('en-CA', { weekday: 'long', timeZone: 'UTC' }).format(next);
    return `Ships ${label}`;
  }
  function progressState(total, threshold, currency, country) {
    if (currency !== 'CAD' || country !== 'CA') return { message: 'Shipping options available at checkout', progress: 0, hidden: true };
    const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    const remaining = Math.max(0, threshold - total);
    return {
      message: total === 0 ? `Free shipping over ${money(threshold)} CAD*` : remaining > 0 ? `${money(remaining)} CAD away from free shipping*` : 'Free-shipping threshold reached*',
      progress: Math.min(100, Math.max(0, total / threshold * 100)), hidden: false
    };
  }
  // Exposed only to Node's test runner, never as a storefront global.
  if (typeof module !== 'undefined' && module.exports) module.exports = { dispatchMessage, progressState };
  if (typeof customElements === 'undefined' || customElements.get('bps-shipping-bar')) return;
  let backdropDialog = null;
  const outsideDialog = event => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return null;
    const bounds = dialog.getBoundingClientRect();
    return event.clientX < bounds.left || event.clientX > bounds.right ||
      event.clientY < bounds.top || event.clientY > bounds.bottom ? dialog : null;
  };
  document.addEventListener('pointerdown', event => {
    backdropDialog = outsideDialog(event);
  }, true);
  document.addEventListener('click', event => {
    const dialog = outsideDialog(event);
    if (dialog && dialog === backdropDialog) dialog.close();
    backdropDialog = null;
  }, true);
  class ShippingBar extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      this.querySelector('[data-bps-bar-info]').onclick = () => dialog.showModal();
      this.querySelector('[data-bps-bar-close]').onclick = () => dialog.close();
      this.onCart = event => {
        if (Number.isFinite(event.detail?.total_price)) { this.request?.abort(); this.request = null; this.render(event.detail); }
        else this.refresh();
      };
      this.onFocus = () => { this.updateDispatch(); this.refresh(); };
      window.addEventListener('cartcount:update', this.onCart);
      window.addEventListener('focus', this.onFocus);
      window.addEventListener('pageshow', this.onFocus);
      this.timer = setInterval(() => this.updateDispatch(), 60000);
      this.render({ total_price: Number(this.dataset.total), currency: this.dataset.currency });
      this.refresh();
    }
    disconnectedCallback() {
      window.removeEventListener('cartcount:update', this.onCart);
      window.removeEventListener('focus', this.onFocus);
      window.removeEventListener('pageshow', this.onFocus);
      clearInterval(this.timer);
      this.request?.abort();
    }
    updateDispatch() {
      const dates = (this.dataset.closedDates || '').split(/[\s,]+/).filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date));
      const message = dispatchMessage(new Date(), dates);
      this.querySelectorAll('[data-bps-dispatch], [data-bps-popup-dispatch]').forEach(el => { el.textContent = message; });
    }
    render(cart) {
      const state = progressState(cart.total_price, Math.max(1, Number(this.dataset.threshold)), cart.currency || this.dataset.currency, this.dataset.country);
      const message = this.querySelector('[data-bps-shipping-message]');
      if (message.textContent.trim() !== state.message) message.textContent = state.message;
      this.querySelector('[data-bps-shipping-progress]').style.width = `${state.progress}%`;
      this.querySelector('.bps-shipping__track').hidden = state.hidden;
      this.updateDispatch();
    }
    async refresh() {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      try {
        const response = await fetch(this.dataset.cartUrl, { signal: request.signal, headers: { Accept: 'application/json' } });
        if (response.ok && this.isConnected && this.request === request) this.render(await response.json());
      } catch (_) { /* Retain the server-rendered message if the cart request fails. */ }
    }
  }
  customElements.define('bps-shipping-bar', ShippingBar);
})();
